import React, { useState } from 'react';

function SellerForm({ seller, onSave, onCancel }) {
  const blank = { name:'', email:'', phone:'', goal_monthly:'' };
  const [f, setF] = useState({ ...blank, ...(seller||{}), goal_monthly: seller?.goal_monthly ?? '' });
  const set = (k,v) => setF(p=>({...p,[k]:v}));
  const inp = "apple-input w-full px-3 py-2 text-sm";
  const submit = (e) => {
    e.preventDefault();
    onSave({ ...f, goal_monthly: f.goal_monthly === '' ? null : Number(f.goal_monthly) });
  };
  return <form onSubmit={submit} className="space-y-3">
    <input required className={inp} placeholder="Nome *" value={f.name} onChange={e=>set('name',e.target.value)} />
    <input className={inp} placeholder="E-mail" type="email" value={f.email} onChange={e=>set('email',e.target.value)} />
    <input className={inp} placeholder="Telefone / WhatsApp" value={f.phone} onChange={e=>set('phone',e.target.value)} />
    <div>
      <label className="text-xs text-gray-500 font-medium mb-1 block">🎯 Meta mensal de receita fechada</label>
      <input className={inp} type="number" min="0" step="100" placeholder="Ex: 15000"
        value={f.goal_monthly} onChange={e=>set('goal_monthly',e.target.value)} />
      <p className="t-caption-2 text-gray-400 mt-1">Some o valor mensal dos leads fechados por ele.</p>
    </div>
    <div className="flex gap-2 pt-1">
      <button type="submit" className="flex-1 bg-blue-500 text-white rounded-full py-2 text-sm font-semibold hover:bg-blue-600">Salvar</button>
      <button type="button" onClick={onCancel} className="flex-1 bg-gray-100 text-gray-600 rounded-full py-2 text-sm font-semibold hover:bg-gray-200">Cancelar</button>
    </div>
  </form>;
}

// ─── SellersView ──────────────────────────────────────────

export { SellerForm };
